import { render, staticRenderFns } from "./PermissionPage.vue?vue&type=template&id=26415fb6&scoped=true&"
import script from "./PermissionPage.vue?vue&type=script&lang=js&"
export * from "./PermissionPage.vue?vue&type=script&lang=js&"
import style0 from "./PermissionPage.vue?vue&type=style&index=0&id=26415fb6&scoped=true&lang=css&"
import style1 from "./PermissionPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26415fb6",
  null
  
)

export default component.exports